import React, { useState } from 'react';
import { FormComponent, UiComponent } from 'components';
import { OrganizationQuery, RoleQuery } from 'queries';
import useModal from 'hooks/useModal';
import { toast } from 'react-toastify';
import { DEFAULT_ERROR_MESSAGE } from 'data/message';

interface Props {
  onCreated?: (roleId: number) => void;
}

// 역할 등록 — 권한은 등록 후 오른쪽 패널에서 체크
function RoleForm({ onCreated }: Props) {
  const { handleClose, handleAlert } = useModal();
  const { data: orgs = [] } = OrganizationQuery.useGetAll();
  const { mutateAsync: create, isPending } = RoleQuery.useCreate();

  const [orgId, setOrgId] = useState('');
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');

  const handleSubmit = async () => {
    if (!orgId) {
      handleAlert('조직을 선택해주세요');
      return;
    }
    if (!name.trim()) {
      handleAlert('역할 이름을 입력해주세요');
      return;
    }
    try {
      const { data } = await create({
        scope: Number(orgId),
        name: name.trim(),
        description: description.trim() || undefined,
        permissionIds: [],
      });
      toast.success('역할이 등록되었습니다.');
      handleClose();
      onCreated?.(data.id);
    } catch {
      toast.error(DEFAULT_ERROR_MESSAGE);
    }
  };

  return (
    <div css={{ width: 400, '> p': { margin: '16px 0 8px', fontWeight: 600 } }}>
      <p>조직</p>
      <select
        value={orgId}
        onChange={(e) => setOrgId(e.target.value)}
        css={{
          width: '100%',
          padding: '8px 12px',
          border: '1px solid #ddd',
          borderRadius: 4,
        }}
      >
        <option value="">조직 선택</option>
        {orgs.map((o) => (
          <option key={o.id} value={o.id}>
            {o.displayName}
          </option>
        ))}
      </select>
      <p>이름</p>
      <FormComponent.Input
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder="예) 행사 담당"
        maxLength={50}
        css={{ width: '100%' }}
      />
      <p>설명</p>
      <FormComponent.Textarea
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        css={{ width: '100%' }}
      />
      <div css={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
        <UiComponent.Button
          type="button"
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={isPending}
        >
          등록하기
        </UiComponent.Button>
      </div>
    </div>
  );
}

export default RoleForm;
